import { render, staticRenderFns } from "./VisionV2.html?vue&type=template&id=4c8a7b6f&scoped=true&"
import script from "./VisionV2.js?vue&type=script&lang=js&"
export * from "./VisionV2.js?vue&type=script&lang=js&"
import style0 from "./VisionV2.scss?vue&type=style&index=0&id=4c8a7b6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a7b6f",
  null
  
)

export default component.exports